export enum EntityWalletTransactionType {
    FromWallet,
    FromDuePayment
}
